var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _path5, _rect6, _path6, _rect7, _path7, _rect8, _path8, _rect9, _path9, _rect10, _path10, _path11, _rect11, _circle, _rect12, _circle2, _rect13, _circle3, _rect14, _circle4, _rect15, _circle5, _rect16, _circle6, _rect17, _circle7, _rect18, _circle8, _rect19, _circle9, _rect20, _circle10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadExtend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 1946,
    viewBox: "0 0 216 1946",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 118.25,
    y: 954.25,
    width: 95.5,
    height: 0.5,
    stroke: "#263152",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 955H214",
    stroke: "#263152",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 118.25,
    y: 290.25,
    width: 95.5,
    height: 0.5,
    stroke: "#263152",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 291H214",
    stroke: "#263152",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 98.25,
    width: 95.5,
    height: 0.5,
    stroke: "#263152",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 99H98",
    stroke: "#263152",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 447.25,
    width: 95.5,
    height: 0.5,
    stroke: "#263152",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 448H98",
    stroke: "#263152",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 118.25,
    y: 593.25,
    width: 95.5,
    height: 0.5,
    stroke: "#263152",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118 594H214",
    stroke: "#263152",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 762.25,
    width: 95.5,
    height: 0.5,
    stroke: "#263152",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 763H98",
    stroke: "#263152",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 1169.25,
    width: 95.5,
    height: 0.5,
    stroke: "#263152",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1170H98",
    stroke: "#263152",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 118.25,
    y: 1407.25,
    width: 95.5,
    height: 0.5,
    stroke: "#263152",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118 1408H214",
    stroke: "#263152",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 1657.25,
    width: 95.5,
    height: 0.5,
    stroke: "#263152",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1658H98",
    stroke: "#263152",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 118.25,
    y: 1872.25,
    width: 95.5,
    height: 0.5,
    stroke: "#263152",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118 1873H214",
    stroke: "#263152",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108 97.5V1873.5",
    stroke: "#263152",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 744,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#263152"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 762,
    r: 10,
    fill: "#6C84F8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 575,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#263152"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 593,
    r: 10,
    fill: "#6C84F8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 429,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#263152"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 447,
    r: 10,
    fill: "#6C84F8"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 272,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#263152"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 290,
    r: 10,
    fill: "#6C84F8"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 80,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#263152"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 98,
    r: 10,
    fill: "#6C84F8"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 1389,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#263152"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 1407,
    r: 10,
    fill: "#6C84F8"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 1151,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#263152"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 1169,
    r: 10,
    fill: "#6C84F8"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 936,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#263152"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 954,
    r: 10,
    fill: "#6C84F8"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 1639,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#263152"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 1657,
    r: 10,
    fill: "#6C84F8"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 1854,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#263152"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 1872,
    r: 10,
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadExtend);
export default __webpack_public_path__ + "static/media/roadExtend.8a6c0cbe7a41d436aba0c266ac4113cc.svg";
export { ForwardRef as ReactComponent };